const getTime = val => {
  if (!val || val === -1 || val === '-1') {
    return 0;
  }
  return new Date(val).getTime();
};

export default getTime;
